// extracted by mini-css-extract-plugin
module.exports = {"title":"view-failed-activation_title__2HQyI","blurb":"view-failed-activation_blurb__3iaH2"};